
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
    'apiKey': "AIzaSyB8DOZoh5graonnkPo5Pxz64Hm4Nbeg7-g" 
  };

const firebaseApp = initializeApp(firebaseConfig);
const firebaseAuthRef = getAuth(firebaseApp)

export default firebaseAuthRef;
